import React from 'react';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import { SectionTitle } from 'apps/group/styles';
import { Form } from 'libs/forms/index';

import { SettingsSection, FullWidthDivider } from 'legacyComponents/styled/lib';
import Spinner from 'components/Spinner';
import { EmailPreferencesAppManager } from 'apps/profile/settings/tabs/notifications/emailPreferences/appManager';

@withNamespaces()
@observer
export class EmailPreferences extends React.Component {
  constructor(props) {
    super(props);
    this.appManager = new EmailPreferencesAppManager(null, {});
  }

  render() {
    const { loading, form, Submit } = this.appManager;
    if (loading) {
      return (
        <SettingsSection>
          <Spinner margin='30px auto' />
        </SettingsSection>
      );
    }
    return (
      <div>
        <SettingsSection>
          <SectionTitle level={2} size='medium'>
            Email Preferences
          </SectionTitle>
          <FullWidthDivider />
          <Form
            formStore={form}
            buttonHandler={Submit}
            formTitleCentered={false}
            noBorder={true}
            responsive
            padding='0px 0px 20px 0px'
            actionProps={{
              outline: true,
            }}
          />
        </SettingsSection>
      </div>
    );
  }
}
